__turbopack_context__.v({
  "checkbox": "ColourRefinement-module-scss-module__XSfUmq__checkbox",
  "count": "ColourRefinement-module-scss-module__XSfUmq__count",
  "item": "ColourRefinement-module-scss-module__XSfUmq__item",
  "label": "ColourRefinement-module-scss-module__XSfUmq__label",
  "labelText": "ColourRefinement-module-scss-module__XSfUmq__labelText",
  "list": "ColourRefinement-module-scss-module__XSfUmq__list",
  "swatch": "ColourRefinement-module-scss-module__XSfUmq__swatch",
});
